import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/villkor/skolor")({
  head: () => ({
    meta: [
      { title: "Regler för skolor — Skolvyn" },
      { name: "description", content: "Regler för skolor som publicerar egna texter och bilder på Skolvyn." },
      { property: "og:title", content: "Regler för skolor — Skolvyn" },
      { property: "og:description", content: "Regler för skolor som publicerar egna texter och bilder på Skolvyn." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: SchoolRules,
});

function SchoolRules() {
  return (
    <LegalLayout
      eyebrow="Juridik"
      title="Regler för skolor på Skolvyn"
      updated="23 september 2026"
      intro="Gäller från 23 september 2026. När ni tagit över er sida publicerar ni själva, direkt."
    >
      <LegalSection id="det-har-galler" title="Det här gäller">
        <ul>
          <li>Ni har rätt att använda varje bild och text ni lägger upp. Inget är hämtat från någon annan utan tillstånd.</li>
          <li>Syns elever eller andra personer har ni deras samtycke — för barn vårdnadshavarens. Ni ansvarar för att ni får lämna uppgifterna till oss.</li>
          <li>Det ni skriver om skolan är sant.</li>
          <li>Inga uppgifter om enskilda elever.</li>
          <li>Innehållet handlar om skolan, inte om något annat ni säljer.</li>
        </ul>
      </LegalSection>
      <LegalSection id="vem-far-skriva" title="Vem som får skriva">
        <p>Den som tagit över sidan, och de kollegor hon bjuder in. Skolan ansvarar för allt som publiceras från era konton.</p>
      </LegalSection>
      <LegalSection id="ert-innehall" title="Ert innehåll är ert">
        <p>Ni äger era texter och bilder. Genom att lägga upp dem ger ni oss rätt att visa dem på Skolvyn och i länkförhandsvisningar, så länge de ligger uppe. Tar ni bort något slutar vi visa det.</p>
      </LegalSection>
      <LegalSection id="om-nagot-ar-fel" title="Om något är fel">
        <p>Föräldrar och andra kan anmäla innehåll på er sida. Vi kan dölja innehåll eller stänga av sidan, och ni får alltid veta varför. Den offentliga informationen från Skolverket finns kvar.</p>
      </LegalSection>
      <LegalSection id="andringar" title="Om reglerna ändras">
        <p>Vi mejlar er innan ändringar börjar gälla.</p>
      </LegalSection>
      <p>Har ni frågor, eller tycker ni att vi tagit fel beslut: hör av er till oss på <a href="mailto:hej@skolvyn.se">hej@skolvyn.se</a>.</p>
    </LegalLayout>
  );
}